<script setup>
import Card from '@/Components/Card/Card.vue';
import PropertyListItem from '@/Pages/HeaderAnalysis/Partials/PropertyListItem.vue';
import AuthResultsResult from '@/Pages/HeaderAnalysis/Partials/AuthResultsResult.vue';
import { formatProperty } from '@/Pages/HeaderAnalysis/header-analysis-utils.js';

defineProps({
  arcInstance: Object
});
</script>

<template>
  <Card class="bg-white-500!" :pad-bottom="true">
    <div class="flex flex-col gap-6">
      <div class="flex flex-col gap-1">
        <div class="font-bold">
          {{ $t('header_analysis.partials.arc_detail.seal') }}
        </div>
        <PropertyListItem
          v-for="(value, prop) in arcInstance.seal"
          :key="prop"
          :title-class="['w-1/6', 'shrink-0', 'capitalize']"
          :title="prop.replaceAll('_', ' ')"
          :value="formatProperty(prop, value)"
        />
      </div>

      <div class="flex flex-col gap-1">
        <div class="font-bold">
          {{ $t('header_analysis.partials.arc_detail.message_signature') }}
        </div>
        <PropertyListItem
          v-for="(value, prop) in arcInstance.signature"
          :key="prop"
          :title-class="['w-1/6', 'shrink-0', 'capitalize']"
          :title="prop.replaceAll('_', ' ')"
          :value="formatProperty(prop, value)"
          :hide-nulls="true"
          :array-as-column="true"
        />
      </div>

      <div class="flex flex-col gap-2">
        <div class="font-bold">
          {{ $t('header_analysis.partials.arc_detail.results') }}
        </div>
        <Card
          v-for="(result, index) in arcInstance.results.results"
          :key="index"
          class="bg-grey-500/10!"
        >
          <div class="flex flex-col gap-1">
            <div class="font-bold">
              {{ result.method.toUpperCase() }} Result
            </div>
            <div class="flex">
              <div class="w-1/6">
                {{ $t('header_analysis.partials.arc_detail.result') }}
              </div>
              <AuthResultsResult :result="result.result" />
            </div>
            <PropertyListItem
              v-for="(val, prop) in {
                comments: result.comments,
                ...result.properties
              }"
              :key="prop"
              :title="prop"
              :value="formatProperty(prop, val)"
              :title-class="['w-1/6', 'shrink-0']"
              :hide-nulls="true"
            />
          </div>
        </Card>
      </div>
    </div>
  </Card>
</template>
